// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_JSDate from "../Data.JSDate/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_UTCTime from "../Data.UTCTime/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Unscramble from "../Unscramble/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var fromEnum = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumDay);
var fromEnum1 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumHour);
var fromEnum2 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumMillisecond);
var fromEnum3 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumMinute);
var sub = /* #__PURE__ */ Data_Numeric.sub(Data_Numeric.additiveInt);
var fromEnum4 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumMonth);
var fromEnum5 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumSecond);
var fromEnum6 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumYear);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var add = /* #__PURE__ */ Data_Numeric.add(Data_Numeric.additiveInt);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var toEnum = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumHour);
var toEnum1 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumMinute);
var toEnum2 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumSecond);
var toEnum3 = /* #__PURE__ */ Data_Enum.toEnum(Data_Time_Component.boundedEnumMillisecond);
var join = /* #__PURE__ */ Control_Bind.join(Data_Maybe.bindMaybe);
var toEnum4 = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumYear);
var toEnum5 = /* #__PURE__ */ Data_Enum.toEnum(Data_Date_Component.boundedEnumDay);
var show1 = /* #__PURE__ */ Data_Show.show(Data_DateTime.showDateTime);
var negate = /* #__PURE__ */ Data_Numeric.negate(Data_Numeric.additiveNumber);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var adjust = /* #__PURE__ */ Data_DateTime.adjust(Data_Time_Duration.durationHours);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Date.eqDate);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_Time.eqTime);
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
var bind1 = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var decode = /* #__PURE__ */ Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var TZLabel = function (x) {
    return x;
};
var LocalDateTime = /* #__PURE__ */ (function () {
    function LocalDateTime(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    LocalDateTime.create = function (value0) {
        return function (value1) {
            return new LocalDateTime(value0, value1);
        };
    };
    return LocalDateTime;
})();
var showTZLabel = Data_Show.showString;
var show2 = /* #__PURE__ */ Data_Show.show(showTZLabel);
var showLocalDateTime = {
    show: function (v) {
        return DateUtils.formatISODate(v.value0) + (" " + DateUtils.formatISOTime(v.value1));
    }
};
var show3 = /* #__PURE__ */ Data_Show.show(showLocalDateTime);
var parseTZLabel = function (str) {
    var $66 = $foreign.zoneExists(str);
    if ($66) {
        return new Data_Maybe.Just(str);
    };
    return Data_Maybe.Nothing.value;
};
var udecodeTZLabel = {
    unsafeDecode: function (f) {
        var str = Unscramble.decodeString(f);
        var v = parseTZLabel(str);
        if (v instanceof Data_Maybe.Just) {
            return v.value0;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Unscramble.decodingError("Invalid time zone: " + show(str));
        };
        throw new Error("Failed pattern match at Data.Time.Local (line 63, column 7 - line 65, column 71): " + [ v.constructor.name ]);
    }
};
var unsafeParseTZLabel = function (str) {
    var v = parseTZLabel(str);
    if (v instanceof Data_Maybe.Just) {
        return v.value0;
    };
    if (v instanceof Data_Maybe.Nothing) {
        return Partial_Unsafe.unsafeCrashWith("unsafeParseTZLabel: Invalid TZLabel: " + show(str));
    };
    throw new Error("Failed pattern match at Data.Time.Local (line 82, column 3 - line 84, column 85): " + [ v.constructor.name ]);
};
var utc = /* #__PURE__ */ unsafeParseTZLabel("UTC");
var localTime = function (v) {
    return v.value1;
};
var localDate = function (v) {
    return v.value0;
};
var localDateTimeToUtc = function (tz) {
    return function (localDateTime) {
        var jsDate = Effect_Unsafe.unsafePerformEffect(Data_JSDate.jsdateLocal({
            day: Data_Int.toNumber(fromEnum(Data_Date.day(localDate(localDateTime)))),
            hour: Data_Int.toNumber(fromEnum1(Data_Time.hour(localTime(localDateTime)))),
            millisecond: Data_Int.toNumber(fromEnum2(Data_Time.millisecond(localTime(localDateTime)))),
            minute: Data_Int.toNumber(fromEnum3(Data_Time.minute(localTime(localDateTime)))),
            month: Data_Int.toNumber(sub(fromEnum4(Data_Date.month(localDate(localDateTime))))(1)),
            second: Data_Int.toNumber(fromEnum5(Data_Time.second(localTime(localDateTime)))),
            year: Data_Int.toNumber(fromEnum6(Data_Date.year(localDate(localDateTime))))
        }));
        var utcJsDate = $foreign.zonedTimeToUtc(jsDate, tz);
        var v = map(Data_UTCTime.UTCTime)(Data_JSDate.toDateTime(utcJsDate));
        if (v instanceof Data_Maybe.Just) {
            return v.value0;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Partial_Unsafe.unsafeCrashWith("localDateTimeToUtc(" + (show3(localDateTime) + (", " + (show2(tz) + ("): returned invalid datetime: " + Effect_Unsafe.unsafePerformEffect(Data_JSDate.toISOString(utcJsDate)))))));
        };
        throw new Error("Failed pattern match at Data.Time.Local (line 134, column 5 - line 139, column 64): " + [ v.constructor.name ]);
    };
};
var fromZeroBasedMonthIndex = /* #__PURE__ */ (function () {
    var $95 = Data_Enum.toEnum(Data_Date_Component.boundedEnumMonth);
    return function ($96) {
        return $95((function (v) {
            return add(v)(1);
        })($96));
    };
})();
var fromTimeComponents = function (x) {
    return apply(apply(apply(map(Data_Time.Time.create)(toEnum(x.hours)))(toEnum1(x.minutes)))(toEnum2(x.seconds)))(toEnum3(x.milliseconds));
};
var fromDateTimeUTC = function (dt) {
    return Data_JSDate.fromDateTime(dt);
};
var fromDateComponents = function (x) {
    return join(apply(apply(map(Data_Date.exactDate)(toEnum4(x.year)))(fromZeroBasedMonthIndex(x.month)))(toEnum5(x.day)));
};
var fromDateTimeComponents = function (x) {
    return apply(map(LocalDateTime.create)(fromDateComponents(x)))(fromTimeComponents(x));
};
var fromJSDateLocal = function (jsDate) {
    return fromDateTimeComponents($foreign.getJSDateComponentsLocal(jsDate));
};
var utcToLocalDateTime = function (dt) {
    return function (tz) {
        var jsDate = fromDateTimeUTC(dt);
        var local = $foreign.utcToZonedTime(jsDate, tz);
        var v = fromJSDateLocal(local);
        if (v instanceof Data_Maybe.Just) {
            return v.value0;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Partial_Unsafe.unsafeCrashWith("utcToLocalDateTime(" + (show1(dt) + (", " + (show2(tz) + ("): returned invalid datetime: " + Effect_Unsafe.unsafePerformEffect(Data_JSDate.toISOString(local)))))));
        };
        throw new Error("Failed pattern match at Data.Time.Local (line 109, column 5 - line 114, column 60): " + [ v.constructor.name ]);
    };
};
var getLogicalDay = function (tz) {
    return function (startOfDayOffset) {
        return function (t) {
            var offset = Data_Time_Duration.Hours(negate(Data_Int.toNumber(unwrap(startOfDayOffset))));
            var logicalTime = Data_Maybe.fromMaybe(t)(adjust(offset)(t));
            var v = utcToLocalDateTime(logicalTime)(tz);
            return v.value0;
        };
    };
};
var getEndOfTheDay = function (tz) {
    return function (startOfDayOffset) {
        return function (currentTime) {
            var logicalDate = getLogicalDay(tz)(startOfDayOffset)(currentTime);
            var mEndOfTheDayLocalDateTime = bind(Data_Date.adjust(1.0)(logicalDate))(function (tommorowDate) {
                return bind(toEnum(unwrap(startOfDayOffset)))(function (endHour) {
                    return bind(toEnum1(0))(function (endMinute) {
                        return bind(toEnum2(0))(function (endSecond) {
                            return bind(toEnum3(0))(function (endMilisecond) {
                                return pure(new LocalDateTime(tommorowDate, new Data_Time.Time(endHour, endMinute, endSecond, endMilisecond)));
                            });
                        });
                    });
                });
            });
            var localDateTime = utcToLocalDateTime(unwrap(currentTime))(tz);
            return Data_Maybe.fromMaybe(localDateTime)(mEndOfTheDayLocalDateTime);
        };
    };
};
var utcToLocalDateTime$prime = function (v) {
    return utcToLocalDateTime(v);
};
var localNow = function (dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var bind2 = Control_Bind.bind(Monad0.Bind1());
    var now = Data_UTCTime.now(dictMonadEffect);
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    return function (tz) {
        return bind2(now)(function (now1) {
            return pure2(utcToLocalDateTime$prime(now1)(tz));
        });
    };
};
var eqTZLabel = Data_Eq.eqString;
var eqLocalDateTime = {
    eq: function (v) {
        return function (v1) {
            return eq(v.value0)(v1.value0) && eq1(v.value1)(v1.value1);
        };
    }
};
var encodeTZLabel = {
    encode: function (v) {
        return encode(v);
    }
};
var decodeTZLabel = {
    decode: function (f) {
        return bind1(decode(f))(function (str) {
            var v = parseTZLabel(str);
            if (v instanceof Data_Maybe.Just) {
                return pure1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid time zone: " + show(str)));
            };
            throw new Error("Failed pattern match at Data.Time.Local (line 54, column 5 - line 56, column 73): " + [ v.constructor.name ]);
        });
    }
};
export {
    LocalDateTime,
    TZLabel,
    getEndOfTheDay,
    getLogicalDay,
    localDate,
    localDateTimeToUtc,
    localNow,
    localTime,
    parseTZLabel,
    unsafeParseTZLabel,
    utc,
    utcToLocalDateTime,
    utcToLocalDateTime$prime,
    eqTZLabel,
    showTZLabel,
    decodeTZLabel,
    udecodeTZLabel,
    encodeTZLabel,
    showLocalDateTime,
    eqLocalDateTime
};
